<template lang="html">
    <vs-popup :active.sync="$props.popupActive" :title=" $props.prospect_url">
<div v-if="isLoading"><CircularLoader/> </div>
        <vs-table
        v-else
		search
		stripe pagination max-items="25"
		:data="internalTabs"
		:max-height= "tableHeight + 'px'"
		id="tb"
        ref="indexable-table"
		noDataText="Aucune internal corresponde"
    >
	<template slot="header">
        <h3>
            Non indexable
        </h3>
      </template>
    <template slot="thead">
	<vs-th class="th-sticky" sort-key="name">URL</vs-th>
	<vs-th class="th-sticky pdl0" sort-key="priority">Code HTTP</vs-th>
	<vs-th class="th-sticky pdl0" sort-key="type">Statut</vs-th>
	<vs-th class="th-sticky pdl0" sort-key="urls">Indexable</vs-th>
</template>

    <template slot-scope="{data}">
	<vs-tr :key="index" v-for="(issue, index) in data">
		<vs-td style="width: 10%" :data="issue.name">
			{{ issue.url }}
		</vs-td>
		<vs-td style="width: 10%" :data="issue.name">
			{{ issue.code_http }}
		</vs-td>
		<vs-td style="width: 10%" :data="issue.name">
			{{ issue.status }}
		</vs-td>
		<vs-td style="width: 10%" :data="issue.name">
			{{ issue.index }}
		</vs-td>
	</vs-tr>
</template>
    </vs-table>
             <!-- </vx-card> -->
            </vs-popup>
         </template>

	<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
//import utilsMixin from "@/mixins/utilsMixin.js";
import VueCookies from "vue-cookies";
import store from "@/store/store";
import ScreamingFrog from "@/entities/ScreamingFrog";
import CircularLoader from "../../../widgets/loader/CircularLoader.vue";
export default {
	created() {
		this.fetchinternalTabs();
		//getting orders which belongs to user sign in
	},
	updated() {
		// //console.log("dsadsads");
		// this.getNotes();
	},
	components: { CircularLoader },
	mounted() {},
	name: "SFInternalTabsDetailsPopup",
	mixins: [dbFieldConvertor],
	props: {
		popupActive: {
			type: Boolean,
			required: true,
		},
		prsopect_id: {
			type: Number,
			required: true,
		},
		prospect_url: {
			type: String,
			required: true,
		},
	},

	data() {
		return {
			// apiUrl: this.$store.state.backendApiUrl,
			internalTabs: [],
			isLoading: false,
		};
	},
	computed: {
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
		allCollaborators: () => {
			return store.state.collaborators;
		},
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		apiUrl: () => {
			return store.state.backendApiUrl;
		},
	},
	methods: {
		async fetchinternalTabs() {
			this.isLoading = true;
			this.internalTabs = await ScreamingFrog.internalTabsByProspect(
				this.$props.prsopect_id
			);
			this.internalTabs = this.internalTabs.filter(
				(e) => e.index == "Non indexable"
			);
			this.isLoading = false;
		},
		getIconName(type) {
			let icon = "";
			switch (type) {
				case "Élevée":
					icon = "arrow_upward";
					break;
				case "Moyenne":
					icon = "panorama_fish_eye";
					break;
				case "Faible":
					icon = "arrow_downward";
					break;
				case "Problème":
					icon = "priority_high";
					break;
				case "Avertissement":
					icon = "warning";
					break;
				case "Faible":
					icon = "arrow_circle_down";
					break;
				default:
					icon = "info";
					break;
			}
			return icon;
		},
		getColor(type) {
			let color = "";
			switch (type) {
				case "Élevée":
					color = "danger";
					break;
				case "Moyenne":
					color = "warning";
					break;
				case "Faible":
					color = "info";
					break;
				case "Problème":
					color = "danger";
					break;
				case "Avertissement":
					color = "warning";
					break;
				case "Faible":
					color = "primary";
					break;
				default:
					color = "primary";
					break;
			}
			return color;
		},
	},
	watch: {},
};
</script>
